import { render } from "./ChooseCompetitors.vue?vue&type=template&id=af00bd6a&scoped=true"
import script from "./ChooseCompetitors.vue?vue&type=script&lang=js"
export * from "./ChooseCompetitors.vue?vue&type=script&lang=js"

import "./ChooseCompetitors.vue?vue&type=style&index=0&id=af00bd6a&scoped=true&lang=css"
import "./ChooseCompetitors.vue?vue&type=style&index=1&id=af00bd6a&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af00bd6a"]])

export default __exports__